import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux'; 
import {push} from 'react-router-redux';
import {I18n} from 'react-redux-i18n';

import customer from '../../customer';
const {getActiveStyles, getActiveLogos, isContextLoaded, getActivePermissions} = customer.selectors;

import {areDefinitionsValid, getActiveDefinition, getActivePageSize} from '../selectors';
import {saveLabelStyles, getDefinitions, uploadLogo} from '../actions';

import CloseButton from './CloseButton';
import StyledLabel2Col from './StyledLabel2Col';
import StyledLabel4Col from './StyledLabel4Col';
import StyledLabel2ColLrg from './StyledLabel2ColLrg';
import StyledLabel4ColLrg from './StyledLabel4ColLrg';
import LabelStylePicker from './LabelStylePicker';

import * as permissions from '../../common/userPermissions';

class CustomizeLabelPage extends React.Component {
  constructor(props)
  {
    super(props);

    let styleElements;
    if(props.contextLoaded)
    {
      styleElements = this.resetStyleElements(props.activeStyles, props.activePageSize);
    }

    this.state = {
      styleElements: styleElements
    };
  }

  componentWillMount() {
    const labelAccess = this.props.activePermissions.find((permission) => {
      return permission === permissions.ACCESS_LABELS;
    });
    if(!labelAccess)
    {
      this.props.actions.push('/labels');
    } 
    else if(this.props.contextLoaded === false) {
      this.props.actions.push('/labels');
    }
  }

  resetStyleElements(activeStyles, activePageSize)
  {
    const styleElements = activeStyles[activePageSize];
        
    const labelBorderStyle = styleElements.find((element) => {
      return element.Name === 'labelborder';
    });
    let labelBorderColorCode = '#FFFFFF';
    if(labelBorderStyle !== undefined)
    {
      labelBorderColorCode = labelBorderStyle.ColorCode.toLowerCase();
    }
    
    const labelBgStyle = styleElements.find((element) => {
      return element.Name === 'background';
    });
    const labelBgColorCode = labelBgStyle.ColorCode.toLowerCase();

    const headerBgStyle = styleElements.find((element) => {
      return element.Name === 'headerbackground';
    });
    const headerBgColorCode = headerBgStyle.ColorCode.toLowerCase();
    
    const headerFontStyle = styleElements.find((element) => {
      return element.Name === 'headercolor';
    });
    const headerFontColorCode = headerFontStyle.ColorCode.toLowerCase();

    const detailBgStyle = styleElements.find((element) => {
      return element.Name === 'detailtitlebackground';
    });
    const detailBgColorCode = detailBgStyle.ColorCode.toLowerCase();
    
    const detailFontStyle = styleElements.find((element) => {
      return element.Name === 'detailtitlecolor';
    });
    const detailFontColorCode = detailFontStyle.ColorCode.toLowerCase();
    
    const valueBgStyle = styleElements.find((element) => {
      return element.Name === 'detailvaluebackground';
    });
    const valueBgColorCode = valueBgStyle.ColorCode.toLowerCase();

    const valueFontStyle = styleElements.find((element) => {
      return element.Name === 'detailvaluecolor';
    });
    const valueFontColorCode = valueFontStyle.ColorCode.toLowerCase();

    const priceBgStyle = styleElements.find((element) => {
      return element.Name === 'pricebackground';
    });
    const priceBgColorCode = priceBgStyle.ColorCode.toLowerCase();

    const priceFontStyle = styleElements.find((element) => {
      return element.Name === 'pricecolor';
    });
    const priceFontColorCode = priceFontStyle.ColorCode.toLowerCase();

    const pluFontStyle = styleElements.find((element) => {
      return element.Name === 'pluprice';
    });
    let pluFontColorCode = '#FFFFFF';
    if(pluFontStyle !== undefined)
    {
      pluFontColorCode = pluFontStyle.ColorCode.toLowerCase();
    }

    const barCodeStyle = styleElements.find((element) => {
      return element.Name === 'barcodebackground';
    });
    let barCodeBgColorCode;
    if(barCodeStyle !== undefined)
    {
      barCodeBgColorCode = barCodeStyle.ColorCode.toLowerCase();
    }

    const imageBorderStyle = styleElements.find((element) => {
      return element.Name === 'imageborder';
    });
    let imageBorderColorCode;
    if(imageBorderStyle !== undefined)
    {
      imageBorderColorCode = imageBorderStyle.ColorCode.toLowerCase();
    }

    const rightPanelBgStyle = styleElements.find((element) => {
      return element.Name === 'rightbackground';
    });
    let rightPanelColorCode;
    if(rightPanelBgStyle !== undefined)
    {
      rightPanelColorCode = rightPanelBgStyle.ColorCode.toLowerCase();
    }

    const labelStyleElements = {
      labelBorderColor: labelBorderColorCode,
      labelBgColor: labelBgColorCode,
      headerBgColor: headerBgColorCode,
      headerFontColor: headerFontColorCode,
      detailBgColor: detailBgColorCode,
      detailFontColor: detailFontColorCode,
      valueBgColor: valueBgColorCode,
      valueFontColor: valueFontColorCode,
      priceFontColor: priceFontColorCode,
      priceBgColor: priceBgColorCode,
      pluFontColor: pluFontColorCode,
      barCodeBgColor: barCodeBgColorCode,
      imageBorderColor: imageBorderColorCode,
      rightPanelBgColor: rightPanelColorCode
    };

    return labelStyleElements;
  }

  resetDefaultElements(activeStyles, activePageSize)
  {
    const styleElements = activeStyles[activePageSize];

    const labelBorderStyle = styleElements.find((element) => {
      return element.Name === 'labelborder';
    });
    let labelBorderColorCode = '#FFFFFF';
    if(labelBorderStyle !== undefined)
    {
      labelBorderColorCode = labelBorderStyle.DefaultColorCode.toLowerCase();
    }
    
    const labelBgStyle = styleElements.find((element) => {
      return element.Name === 'background';
    });
    const labelBgColorCode = labelBgStyle.DefaultColorCode.toLowerCase();

    const headerBgStyle = styleElements.find((element) => {
      return element.Name === 'headerbackground';
    });
    const headerBgColorCode = headerBgStyle.DefaultColorCode.toLowerCase();
    
    const headerFontStyle = styleElements.find((element) => {
      return element.Name === 'headercolor';
    });
    const headerFontColorCode = headerFontStyle.DefaultColorCode.toLowerCase();

    const detailBgStyle = styleElements.find((element) => {
      return element.Name === 'detailtitlebackground';
    });
    const detailBgColorCode = detailBgStyle.DefaultColorCode.toLowerCase();
    
    const detailFontStyle = styleElements.find((element) => {
      return element.Name === 'detailtitlecolor';
    });
    const detailFontColorCode = detailFontStyle.DefaultColorCode.toLowerCase();
    
    const valueBgStyle = styleElements.find((element) => {
      return element.Name === 'detailvaluebackground';
    });
    const valueBgColorCode = valueBgStyle.DefaultColorCode.toLowerCase();

    const valueFontStyle = styleElements.find((element) => {
      return element.Name === 'detailvaluecolor';
    });
    const valueFontColorCode = valueFontStyle.DefaultColorCode.toLowerCase();

    const priceBgStyle = styleElements.find((element) => {
      return element.Name === 'pricebackground';
    });
    const priceBgColorCode = priceBgStyle.DefaultColorCode.toLowerCase();

    const priceFontStyle = styleElements.find((element) => {
      return element.Name === 'pricecolor';
    });
    const priceFontColorCode = priceFontStyle.DefaultColorCode.toLowerCase();

    const pluFontStyle = styleElements.find((element) => {
      return element.Name === 'pluprice';
    });
    let pluFontColorCode = '#FFFFFF';
    if(pluFontStyle !== undefined)
    {
      pluFontColorCode = pluFontStyle.DefaultColorCode.toLowerCase();
    }

    const barCodeStyle = styleElements.find((element) => {
      return element.Name === 'barcodebackground';
    });
    let barCodeBgColorCode;
    if(barCodeStyle !== undefined)
    {
      barCodeBgColorCode = barCodeStyle.DefaultColorCode.toLowerCase();
    }

    const imageBorderStyle = styleElements.find((element) => {
      return element.Name === 'imageborder';
    });
    let imageBorderColorCode;
    if(imageBorderStyle !== undefined)
    {
      imageBorderColorCode = imageBorderStyle.DefaultColorCode.toLowerCase();
    }

    const rightPanelBgStyle = styleElements.find((element) => {
      return element.Name === 'rightbackground';
    });
    let rightPanelColorCode = '#FFFFFF';
    if(rightPanelBgStyle !== undefined)
    {
      rightPanelColorCode = rightPanelBgStyle.DefaultColorCode.toLowerCase();
    }
        
    const labelStyleElements = {
      labelBorderColor: labelBorderColorCode,
      labelBgColor: labelBgColorCode,
      headerBgColor: headerBgColorCode,
      headerFontColor: headerFontColorCode,
      detailBgColor: detailBgColorCode,
      detailFontColor: detailFontColorCode,
      valueBgColor: valueBgColorCode,
      valueFontColor: valueFontColorCode,
      priceFontColor: priceFontColorCode,
      priceBgColor: priceBgColorCode,
      pluFontColor: pluFontColorCode,
      barCodeBgColor: barCodeBgColorCode,
      imageBorderColor: imageBorderColorCode,
      rightPanelBgColor: rightPanelColorCode
    };

    return labelStyleElements;
  }

  closeColorPickers = () => {
    this.picker.closeColorPickers();
  }

  handleColorChange = (name, color) => {
    let styleElements = {
      ...this.state.styleElements
    };

    switch(name)
    {
      case 'mainBorder':
      {
        styleElements.labelBorderColor = color.hex;
        break;
      }
      case 'mainBackground':
      {
        styleElements.labelBgColor = color.hex;
        break;
      }
      case 'headerFont':
      {
        styleElements.headerFontColor = color.hex;
        break;
      }
      case 'headerBackground':
      {
        styleElements.headerBgColor = color.hex;
        break;
      }
      case 'detailFont':
      {
        styleElements.detailFontColor = color.hex;
        break;
      }
      case 'detailBackground':
      {
        styleElements.detailBgColor = color.hex;
        break;
      }
      case 'valueFont':
      {
        styleElements.valueFontColor = color.hex;
        break;
      }
      case 'valueBackground':
      {
        styleElements.valueBgColor = color.hex;
        break;
      }
      case 'priceFont':
      {
        styleElements.priceFontColor = color.hex;
        break;
      }
      case 'priceBackground':
      {
        styleElements.priceBgColor = color.hex;
        break;
      }
      case 'pluFont':
      {
        styleElements.pluFontColor = color.hex;
        break;
      }
      case 'barCodeBackground':
      {
        styleElements.barCodeBgColor = color.hex;
        break;
      }
      case 'imageBorder':
      {
        styleElements.imageBorderColor = color.hex;
        break;
      }
      case 'rightPanelBackground':
      {
        styleElements.rightPanelBgColor = color.hex;
      }
    }
    this.setState({styleElements});
  }

  handleRestoreDefault = () => {
    const styleElements = this.resetDefaultElements(this.props.activeStyles, this.props.activePageSize);
    this.setState({styleElements: styleElements});
  }



  handleSave = () => {
    this.props.actions.saveLabelStyles(this.props.activeDefinition, this.state.styleElements);
    this.props.actions.push('/labels');
  }

  handleLogoUpload = (file) => {
    this.props.actions.uploadLogo(this.props.activePageSize, file);
  }

  render() {
    const {activeDefinition, activeLogos, activePageSize, contextLoaded, definitionsValid} = this.props;
    let large = false;
    if(activePageSize === '195 x 66 mm' || activePageSize == '91 x 130 mm' || activePageSize == '133 x 191 mm')
    {
      large = true;
    }

    let logo = '';
    let columns = -1;
    if(definitionsValid)
    {
      const fieldColumns = activeDefinition.FieldMappings.map((mapping) => {
        return mapping.Column;
      });
      
      // We need the max column to select the proper label template
      columns = fieldColumns.reduce((prev, current) => {
        return (prev > current) ? prev : current;
      });
    }
    
    if(contextLoaded)
    {
      logo = activeLogos[activePageSize];
    }

    return (
      <div id="wrapper" onClick={this.closeColorPickers}> 
        <div className="container-fluid main label-customize full-width" id="main">
          <div className="row" onClick={this.closeColorPickers}>
            <div className="col-lg-12">
              <h1 className="float-left">{I18n.t('CUSTOMIZE_LABEL')}</h1>
              <CloseButton url="/labels"/>
            </div>
          </div>

          {(columns === 0 && large === false) && <StyledLabel2Col styleElements={this.state.styleElements} logoUrl={logo}/>}
          {(columns === 0 && large === true) && <StyledLabel2ColLrg styleElements={this.state.styleElements} logoUrl={logo}/>}
          {(columns === 1 && large === false) && <StyledLabel4Col styleElements={this.state.styleElements} logoUrl={logo}/>}
          {(columns === 1 && large === true) && <StyledLabel4ColLrg styleElements={this.state.styleElements} logoUrl={logo}/>}

          {(definitionsValid && activeDefinition !== null) && <LabelStylePicker ref={instance => this.picker = instance} 
                                                          columnCount={columns} 
                                                          styleElements={this.state.styleElements}
                                                          onColorChange={this.handleColorChange}
                                                          onLogoUpload={this.handleLogoUpload}
                                                          onRestoreDefault={this.handleRestoreDefault}
                                                          logoUrl={logo}/>}

          <div className="row no-gutters bottom-buttons">
            <div className="col-sm-12 text-right">
              <button type="button" className="btn btn-secondary" onClick={this.handleCancel}>{I18n.t('CANCEL')}</button> 
              <button type="button" className="btn btn-primary" onClick={this.handleSave}>{I18n.t('SAVE')}</button> 
            </div>
          </div>

        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeDefinition: getActiveDefinition(state),
    activeLogos: getActiveLogos(state),
    activeStyles: getActiveStyles(state),
    activePageSize: getActivePageSize(state),
    activePermissions: getActivePermissions(state),
    contextLoaded: isContextLoaded(state),
    definitionsValid: areDefinitionsValid(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({push, getDefinitions, saveLabelStyles, uploadLogo}, dispatch)
  };
}

CustomizeLabelPage.propTypes = {
  actions: PropTypes.object.isRequired,
  activeDefinition: PropTypes.object,
  activeLogos: PropTypes.object.isRequired,
  activeStyles: PropTypes.object.isRequired,
  activePageSize: PropTypes.string.isRequired,
  activePermissions: PropTypes.array.isRequired,
  contextLoaded: PropTypes.bool.isRequired,
  definitionsValid: PropTypes.bool.isRequired
};

CustomizeLabelPage.defaultProps = {
  activeLogos: {},
  activeStyles: {}
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomizeLabelPage);



/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/CustomizeLabelPage.js
 **/